//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    'content'
  ],
  computed: {
    link() {
      return this.content.Link
    },
    cleanLink() {
      return this.link.cached_url.replace(/^pages\//, '/')
    }
  },
  mounted() {
    console.log(this.link)
  }
}
